// extracted by mini-css-extract-plugin
export default {"wrapper":"zrVGk","channelsCategory":"YoEyM","activeCategory":"k18jG"};